// extracted by mini-css-extract-plugin
module.exports = {"miniWindow":"MiniWindow_miniWindow__2U-D9","show":"MiniWindow_show__yAELq"};